import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema, type SchemaObject } from "./validation.ts";

/*
Der Webservice ESR_session gibt eine für diese Anfrage eindeutige ID zurück, 
welche für die weiteren Webservices zu der jeweiligen Anfrage mitgegeben werden muss.
*/


export interface ESRFinancialPlanResponse {
  "financial_plan": {
    "facade_insulation": {
      "planned_costs": number,
      "possible_subsidy": number,
      "total_costs": number
    },
    "roof_insulation": {
      "planned_costs": number,
      "possible_subsidy": number,
      "total_costs": number
    },
    "floor_insulation": {
      "planned_costs": number,
      "possible_subsidy": number,
      "total_costs": number
    },
    "window": {
      "planned_costs": number,
      "possible_subsidy": number,
      "total_costs": number
    },
    "heating_system": {
      "planned_costs": number,
      "possible_subsidy": number,
      "total_costs": number
    },
    "ventilation_system": {
      "planned_costs": number,
      "possible_subsidy": number,
      "total_costs": number
    },
    "solar_thermal": {
      "planned_costs": number,
      "possible_subsidy": number,
      "total_costs": number
    },
    "photovoltaics": {
      "planned_costs": number,
      "possible_subsidy": number,
      "total_costs": number
    }
  },
  "building_system": {
    "costs": number,
    "subsidy": number,
    "percentage": number,
    "max_funding": number
  },
  "building_envelope": {
      "isfp": boolean,
      "costs": number,
      "subsidy": number,
      "percentage": number,
      "max_funding": number
  },
  "total_planned_costs": number,
  "total_possible_subsidy": number,
  "total_final_costs": number
}

export const ESRFinancialPlanResponseSchema : SchemaObject = {
  "financial_plan": {
    "facade_insulation": {
      "planned_costs": "number",
      "possible_subsidy": "number",
      "total_costs": "number"
    },
    "roof_insulation": {
      "planned_costs": "number",
      "possible_subsidy": "number",
      "total_costs": "number"
    },
    "floor_insulation": {
      "planned_costs": "number",
      "possible_subsidy": "number",
      "total_costs": "number"
    },
    "window": {
      "planned_costs": "number",
      "possible_subsidy": "number",
      "total_costs": "number"
    },
    "heating_system": {
      "planned_costs": "number",
      "possible_subsidy": "number",
      "total_costs": "number"
    },
    "ventilation_system": {
      "planned_costs": "number",
      "possible_subsidy": "number",
      "total_costs": "number"
    },
    "solar_thermal": {
      "planned_costs": "number",
      "possible_subsidy": "number",
      "total_costs": "number"
    },
    "photovoltaics": {
      "planned_costs": "number",
      "possible_subsidy": "number",
      "total_costs": "number"
    }
  },
  "building_system": {
    "costs": "number",
    "subsidy": "number",
    "percentage": "number",
    "max_funding": "number"
  },
  "building_envelope": {
      "isfp": "boolean",
      "costs": "number",
      "subsidy": "number",
      "percentage": "number",
      "max_funding": "number"
  },
  "total_planned_costs": "number",
  "total_possible_subsidy": "number",
  "total_final_costs": "number"
}
  

export class ESRFinancialPlan extends Request<ESRFinancialPlanResponse>{
    override method : TRequestMethod = "GET";
    override responseSchema : Schema = ESRFinancialPlanResponseSchema;

    constructor (
        public sessionToken: string){
        super();
    }

    override route() : string{
        return `${BASEURL}/financial_plan?sessionToken=${this.sessionToken}`;
    }
}